import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';
import { auth } from '../firebase'; // Import Firebase auth
import { signInWithEmailAndPassword } from 'firebase/auth'; // Import signInWithEmailAndPassword
import { useLoading } from '../contexts/LoadingContext'; // Correct import of useLoading

const SignupInvite = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { isLoading, setLoading } = useLoading(); // Using useLoading hook
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true); // Use setLoading from LoadingContext
    if (token) {
      console.log("Token for validation:", token);
      axios.get(`http://localhost:3001/api/validate-invite?token=${token}`)
        .then(response => {
          setEmail(response.data.email);
          setLoading(false); // Set loading to false upon completion
        })
        .catch(err => {
          console.error('Error in validate-invite:', err);
          setError(err.response?.data?.message || 'Invalid or expired invitation link.');
          setLoading(false); // Set loading to false upon error
        });
    } else {
      setError('No invitation token found.');
      setLoading(false); // Set loading to false if no token found
    }
  }, [token, setLoading]); // Remove db from dependencies

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token) {
      setError('No invitation token provided.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);

    try {
      const accountCreationResponse = await axios.post('http://localhost:3001/api/create-account', {
        email,
        password,
        token
      });

      if (accountCreationResponse.status === 200) {
        await signInWithEmailAndPassword(auth, email, password);
        navigate('/'); // Redirect to the home page after successful login
      }
    } catch (err) {
      console.error('Error during account creation or sign-in:', err);
      setError(err.response?.data?.message || 'Failed to create an account.');
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Container component="main" maxWidth="xs">
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <Typography component="h1" variant="h5">
        Complete Your Signup
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          margin="normal"
          required
          fullWidth
          label="Email Address"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          disabled
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
        >
          Sign Up
        </Button>
      </form>
    </Container>
  );
};

export default SignupInvite;
